import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class StoreService {
    
 constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }
   
   getStore() {
        return this.http.get(this.global.httpUrl+"stores");
   }

   getStoreById(id: any) {
        return this.http.get(this.global.httpUrl+"stores/"+id);
   } 

   createStore(data: any){
        return this.http.post(this.global.httpUrl+"stores", data); 
   }

   updateStore(data: any,id: any){
        return this.http.put(this.global.httpUrl+"stores/"+id, data); 
   } 
}




// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/stores/store.service.ts